import { css, cx } from "@emotion/css";
import { ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

type ChangePasswordLayoutProps = {
  children?: ReactNode;
  className?: string;
};

export const ChangePasswordLayout: React.FC<ChangePasswordLayoutProps> = ({
  children,
  className,
}) => {
  const classes = createStyles(useTheme());

  return <main className={cx(classes.main, className)}>{children}</main>;
};

function createStyles({ spacing, palette }: Theme) {
  return {
    main: css({
      padding: spacing(3),
      backgroundColor: palette.default.background,
    }),
  };
}
